// cleancode-ui/src/components/Dashboard.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Navigation from './Navigation';
import './Login.css'; // Reuse styling for consistency

const Dashboard = ({ onLogout }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [showSuccessBanner, setShowSuccessBanner] = useState(false);

  useEffect(() => {
    // Check if user just completed payment
    const urlParams = new URLSearchParams(location.search);
    const payment = urlParams.get('payment');
    
    if (payment === 'success') {
      setShowSuccessBanner(true);
      // Clear the URL parameter
      window.history.replaceState({}, '', '/dashboard');
      
      // Auto-dismiss the banner after 6 seconds
      setTimeout(() => {
        setShowSuccessBanner(false);
      }, 6000);
    }
  }, [location.search]);

  const handleLogout = () => {
    onLogout();
    navigate('/login');
  };

  return (
    <div>
      <Navigation onLogout={onLogout} />
      
      {/* Success Banner */}
      {showSuccessBanner && (
        <div style={{
          backgroundColor: '#4CAF50',
          color: 'white',
          padding: '15px',
          textAlign: 'center',
          fontSize: '16px',
          fontWeight: 'bold',
          position: 'sticky',
          top: 0,
          zIndex: 1000
        }}>
          ✅ Payment successful! Your subscription is now active. Welcome to CleanCode.ai Pro!
        </div>
      )}
      
      <div className="login-container">
        <div className="login-card">
          <div className="login-header">
            <h1 className="login-title">Welcome to CleanCode.ai!</h1>
            <p className="login-subtitle">AI-powered Swift code review dashboard</p>
          </div>

          <div className="dashboard-content">
            <div className="feature-grid">
              <div className="feature-card">
                <h3>🔍 Code Review</h3>
                <p>Upload files or analyze GitHub PRs with AI-powered code review</p>
                <button 
                  className="login-button"
                  onClick={() => navigate('/review')}
                >
                  Start Review
                </button>
              </div>
              
              <div className="feature-card">
                <h3>📊 Review History</h3>
                <p>View your past code reviews and insights</p>
                <button 
                  className="login-button"
                  onClick={() => navigate('/history')}
                >
                  View History
                </button>
              </div>
              
              <div className="feature-card">
                <h3>⚙️ Settings</h3>
                <p>Configure your review preferences</p>
                <button 
                  className="login-button"
                  onClick={() => navigate('/settings')}
                >
                  Settings
                </button>
              </div>
            </div>
          </div>

          <div className="login-footer">
            <button 
              className="login-button" 
              onClick={handleLogout}
              style={{ background: 'var(--gray)', color: 'var(--dark)' }}
            >
              Logout
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
